import React from 'react';
import { Users, Star, BookOpen, Trophy } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProof() {
  const stats = [{
    icon: Users,
    value: '+500',
    label: 'alumnos interesados'
  }, {
    icon: Star,
    value: '4.9/5',
    label: 'valoración promedio'
  }, {
    icon: BookOpen,
    value: '+5',
    label: 'Módulos de formación estratégica'
  }, {
    icon: Trophy,
    value: '#1',
    label: 'Método elegido para empezar desde cero'
  }];
  return <section className="bg-navy-800 py-8 border-y border-navy-700" data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-177">
          {stats.map((stat, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-178">
              <div className="flex flex-col items-center justify-center p-4" data-id="element-179">
                <stat.icon className="w-8 h-8 text-gold-500 mb-3" data-id="element-180" />
                <div className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-181">
                  {stat.value}
                </div>
                <div className="text-sm text-gray-400" data-id="element-182">{stat.label}</div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}